import keycloakAxios from '@/services/axios';

export const getPaidEventId = async (paymentIntent: string) => {
  const response = await keycloakAxios.post('payments/paid-event-id', {
    paymentIntent
  });

  if (response.status >= 300) {
    throw new Error(
      `Error getting paid event id: Invalid status code: ${response.status}`
    );
  }
  return response.data;
};
